module.exports = __webpack_public_path__ + "static/media/S1_00010.091cbb1c.jpg";